import { Box, Button, TextField } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export const FilteringZone = ({ handleShowAdd, lngsltd, search, setSearch, handleClearFilters }) => {
    return (
        <Box display="flex" alignItems="center" gap={2} width="60%">
            <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder="Search by User or Group"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={handleClearFilters}
            >
                {lngsltd["Clear Filters"]}
            </Button>
            <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleShowAdd()}
                startIcon={<AddIcon />}
            >
               Add User Group
            </Button>

        </Box>
    );
}
